import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTableTennisPaddleBall } from "@fortawesome/free-solid-svg-icons";
import { useLiveTrainingReturnFab } from "../hooks/useLiveTrainingReturnFab";
import { persistLiveTrainingSession } from "../hooks/useLiveTrainingRedirect";
import { clearCoachLiveTrainingAutoEnterSuppress } from "../utils/liveTrainingContext";
import { requestLiveFullscreen } from "../hooks/useLiveFullscreen";
import { normalizeStoredGroupInfo } from "../utils/liveTrainingGroupInfo";
import { ensureCoachRoleForLiveTrainingEntry } from "../utils/liveTrainingNav";
import { readStoredUser } from "../utils/homeRole";
import "../pages/LiveTraining/LiveTrainingPage.css";

export function LiveTrainingReturnFab() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { visible, label, sessionState } = useLiveTrainingReturnFab();

  if (!visible || !sessionState) return null;

  const handleClick = () => {
    requestLiveFullscreen();
    clearCoachLiveTrainingAutoEnterSuppress();
    const user = readStoredUser();
    ensureCoachRoleForLiveTrainingEntry(user, user?.permissions || []);
    const stored = JSON.parse(localStorage.getItem("grpinf") || "null");
    persistLiveTrainingSession(
      sessionState,
      normalizeStoredGroupInfo(stored, sessionState)
    );
    navigate("/live-training");
  };

  return (
    <button
      type="button"
      className="lt-return-fab"
      onClick={handleClick}
      aria-label={t("liveTrainingReturnFab")}
    >
      <span className="lt-return-fab__dot" aria-hidden />
      <FontAwesomeIcon
        icon={faTableTennisPaddleBall}
        className="lt-return-fab__icon"
        aria-hidden
      />
      <span>
        {t("liveTrainingReturnFab")}
        {label ? ` ${label}` : ""}
      </span>
    </button>
  );
}

export default LiveTrainingReturnFab;
